//
//
//
//
//
//
//
//
//
//

import Header from '../components/layout/Header.vue'
import HeaderLasa from '../components/layout/HeaderLasa.vue'
import Footer from '../components/layout/Footer.vue'
import FooterLasa from '../components/layout/FooterLasa.vue'
export default {
    middleware: 'appData',
    components: {
        Header,
        HeaderLasa,
        FooterLasa,
        Footer
    },
    data() {
        return {
            showRightWidow: true,
            navigationType: '',
            headerType: '',
            footerType: ''
        }
    },
    mounted() {
        this.navigationType = localStorage.getItem('navigationType')
        if (!this.navigationType) {
            this.headerType = 'Header'
            this.footerType = 'Footer'
            document.title = '江苏省技术产权交易市场-专利技术转让-专利交易发布-知识产权申请平台'
        } else {
            this.headerType = 'HeaderLasa'
            this.footerType = 'FooterLasa'
            document.title = '拉萨市技术产权交易网-专利技术转让-专利交易发布-知识产权申请平台'
        }
        this.queryHis()
        this.$bus.$on('changeBar', this.changeBar)
    },
    methods: {
        changeBar() {
            this.navigationType = 'lasa'
            localStorage.setItem('navigationType', 'lasa')
            this.headerType = 'HeaderLasa'
            this.footerType = 'FooterLasa'
            document.title = '拉萨市技术产权交易网-专利技术转让-专利交易发布-知识产权申请平台'
        },
        async queryHis() {
            const strCookie = document.cookie
            console.log(strCookie, 'cookie')
            const cookies = strCookie.split(' ')
            let touristId = ''
            cookies.map(str => {
                if (str.includes('NW_TOURIST_ID')) {
                    const tempArr = str.split('=')
                    touristId = tempArr[1]

                    if (touristId.indexOf(';') > 0) {
                        touristId = touristId.substring(0, touristId.length - 1)
                    }
                    localStorage.setItem('TOURIST_ID', touristId)
                }
            })

            const { code, data } = await portal.selectHomePageActivityId({
                body: {
                    touristId
                }
            })
            if (code == '0000') {
                if (data == '202410602943614795') {
                    // 切换拉萨导航栏
                    this.navigationType = 'lasa'
                    localStorage.setItem('navigationType', 'lasa')
                    this.headerType = 'HeaderLasa'
                    this.footerType = 'FooterLasa'
                    document.title = '拉萨市技术产权交易网-专利技术转让-专利交易发布-知识产权申请平台'
                } else {
                    console.log('返回省平台')
                    this.navigationType = ''
                    localStorage.setItem('navigationType', '')
                    this.headerType = 'Header'
                    this.footerType = 'Footer'
                    document.title = '江苏省技术产权交易市场-专利技术转让-专利交易发布-知识产权申请平台'
                }
            }
        }
    }
}
